// [claude-code 2026-03-11] Native compact calendar widget for Mission Control — replaced TradingView embed
// [claude-code 2026-03-12] Reverted to TradingView widget embed — reliable data, TV-style layout
import { useEffect, useRef } from "react";

export function SessionCalendarMini() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let cancelled = false;
    const mountTimer = window.setTimeout(() => {
      if (cancelled || !container.isConnected) return;

      while (container.firstChild) container.removeChild(container.firstChild);

      const widgetDiv = document.createElement("div");
      widgetDiv.className = "tradingview-widget-container__widget";
      widgetDiv.style.width = "100%";
      widgetDiv.style.height = "100%";
      container.appendChild(widgetDiv);

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-events.js";
      script.async = true;
      script.textContent = JSON.stringify({
        colorTheme: "dark",
        isTransparent: true,
        width: "100%",
        height: "100%",
        locale: "en",
        importanceFilter: "0,1",
        countryFilter: "us",
      });
      container.appendChild(script);
    }, 0);

    return () => {
      cancelled = true;
      window.clearTimeout(mountTimer);
      while (container.firstChild) container.removeChild(container.firstChild);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="tradingview-widget-container w-full h-full"
      style={{ minHeight: "180px" }}
    />
  );
}
